module.exports = __webpack_public_path__ + "static/media/paul-logo.83b1c88f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/clients/paul-logo.jpg
 ** module id = 772
 ** module chunks = 0
 **/